const AbiHtsRuleApiUrls = {
  LIST: `${process.env.REACT_APP_USER_ABI_URL}/abi/hts-rule/list`,
  CREATE: `${process.env.REACT_APP_USER_ABI_URL}/abi/hts-rule/create`,
  UPDATE: `${process.env.REACT_APP_USER_ABI_URL}/abi/hts-rule/update`,
  DELETE: `${process.env.REACT_APP_USER_ABI_URL}/abi/hts-rule/delete`,
}

export default AbiHtsRuleApiUrls
